import React from 'react';
import { Image, Typography } from 'antd';
import agroboxImage from '../../assets/agrobox2.png';

const { Title } = Typography;

const CInicioCliente = () => {
  return (
    <div
      style={{
        height: 'calc(70vh - 20px)', // Altura total menos 20px
        display: 'flex', // Activar diseño flexible
        flexDirection: 'column', // Apilar elementos verticalmente
        justifyContent: 'center', // Centrar verticalmente
        alignItems: 'center', // Centrar horizontalmente
        textAlign: 'center', // Alinear texto
        margin: '0', // Eliminar márgenes externos
      }}
    >
      <Image
        src={agroboxImage}
        alt="Agrobox"
        preview={false} // Desactivar vista previa
        style={{ maxWidth: '80%', maxHeight: '80%',marginTop:'30px', objectFit: 'contain' }}
      />
    </div>
  );
};

export default CInicioCliente;
